import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import ProfileSelector from './components/ProfileSelector';
import StudySessionSelector from './components/StudySessionSelector';
import Dashboard from './components/Dashboard';
import Admin from './components/Admin';
import Login from './components/Login';
import { Toaster } from './components/ui/toaster';
import { AuthProvider, useAuth } from './contexts/AuthContext';

function MainApp() {
  const { authenticated, loading } = useAuth();
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [selectedSession, setSelectedSession] = useState(null);

  const handleBackToProfiles = () => {
    setSelectedProfile(null);
    setSelectedSession(null);
  };

  const handleBackToSessions = () => {
    setSelectedSession(null);
  };

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-100 via-blue-50 to-cyan-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-purple-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!authenticated) {
    return <Login />;
  }

  return (
    <div className="App">
      {!selectedProfile ? (
        <ProfileSelector onSelectProfile={setSelectedProfile} />
      ) : !selectedSession ? (
        <StudySessionSelector 
          profile={selectedProfile} 
          onSelectSession={setSelectedSession}
          onBack={handleBackToProfiles}
        />
      ) : (
        <Dashboard 
          profile={selectedProfile} 
          session={selectedSession}
          onBack={handleBackToSessions}
          onBackToProfiles={handleBackToProfiles}
        />
      )}
    </div>
  );
}

// Wrapper component to handle admin routes independently
function AppContent() {
  const location = window.location.pathname;
  
  // If accessing admin route, render Admin component without AuthProvider interference
  if (location === '/admin') {
    return <Admin />;
  }
  
  // For all other routes, use the regular MainApp with authentication
  return <MainApp />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route path="/*" element={
          <AuthProvider>
            <MainApp />
          </AuthProvider>
        } />
      </Routes>
      <Toaster />
    </Router>
  );
}

export default App;
